// LES DUES FORMES DEL SOFT SYSTEMS, i com es passa de l'una a l'altra.
//
// Sense cap import, com els altres dos mapes, perquè es pugui provar sol.
//
// ── AQUÍ LA TRADUCCIÓ ÉS GAIREBÉ LA IDENTITAT, I ÉS A POSTA ──────────────────────────────────
//
// L'esquema porta dues maneres de desar el mateix: **una fila amb un JSONB per etapa** a
// `soft_systems_models`, i **quatre taules normalitzades** (`rich_picture_elements`,
// `rich_picture_connections`, `catwoe_analyses`, `conceptual_activities`). S'ha triat el JSONB i
// **les quatre taules queden mortes**, com les columnes JSONB de `causal_loop_models`: tenir les
// dues coses és tenir dues veritats.
//
// El motiu no és de gust:
//
//   · **Ningú no consulta dins d'una etapa.** No hi ha «troba'm els models amb un interessat que
//     es digui X». Sense consultes, normalitzar només afegeix feina.
//   · **Dins d'un sol document no hi ha cap identificador que canviï de mans.** Les taules
//     demanarien que una connexió de la imatge rica apuntés a un element amb UUID de la base, i
//     llavors tornaríem al parany que en aquest projecte ja ha picat quatre vegades —
//     `parseInt(c.id)`, el prefix `rel_`, els extrems de les fletxes i les referències de dins
//     de les equacions—. Aquí els identificadors del navegador **no surten mai del document**.
//
// Per això aquest fitxer és curt: la feina de debò va ser triar, no traduir.

export const ETAPES = ['problem_situation', 'problem_expressed', 'root_definitions',
                       'conceptual_models', 'comparison', 'changes', 'implementation'];

export const CAMPS = ['problemSituation', 'richPicture', 'rootDefinitions',
                      'conceptualModels', 'comparison', 'changes', 'implementation'];

export const desDeLAPI = (d) => {
  const fora = { stage: ETAPES.includes(d?.stage) ? d.stage : ETAPES[0] };
  for (const c of CAMPS) if (d?.[c] != null) fora[c] = d[c];
  return fora;
};

// EL `PUT` NOMÉS ENVIA EL QUE S'HA DE DESAR, i el servidor deixa estar la resta.
//
// És diferent dels components i dels bucles causals, que substitueixen tot el dibuix. Aquí es
// treballa **etapa per etapa** i durant una sessió llarga: desar mentre s'és a l'etapa 3 no ha
// de poder buidar l'etapa 1 perquè el client, per la raó que sigui, no l'hagi enviada.
export const capALAPI = (dades) => {
  const fora = {};
  if (ETAPES.includes(dades?.stage)) fora.stage = dades.stage;
  for (const c of CAMPS) if (dades?.[c] !== undefined) fora[c] = dades[c];
  return fora;
};

// Si val la pena desar-ho. Un SSM **no és buit perquè no tingui dibuix**: una descripció escrita
// ja és feina d'una classe sencera, i la comprovació dels altres llenços —comptar variables o
// components— aquí diria que no hi ha res quan sí que n'hi ha.
export function teContingut(dades) {
  if (!dades) return false;
  const p = dades.problemSituation || {};
  if (String(p.description || '').trim()) return true;
  if ((p.stakeholders || []).length || (p.concerns || []).length) return true;
  if ((dades.rootDefinitions || []).length) return true;
  const r = dades.richPicture || {};
  if ((r.elements || []).length || (r.strokes || []).length || (r.connections || []).length) return true;
  if ((dades.conceptualModels || []).length) return true;
  for (const c of ['comparison', 'changes', 'implementation']) {
    const v = dades[c] || {};
    if (Object.values(v).some((x) => Array.isArray(x) && x.length)) return true;
  }
  return false;
}

// Quantes etapes tenen alguna cosa. És el que la barra lateral ensenya, i **no és el mateix que
// «per quina vas»**: al SSM es va endavant i endarrere a posta, i marcar com a fetes «les que
// queden abans d'on ets» era una barra de progrés de cascada, que és justament el que Checkland
// va passar-se anys dient que el SSM no és.
export function etapesAmbContingut(dades) {
  if (!dades) return new Set();
  const fetes = new Set();
  const p = dades.problemSituation || {};
  if (String(p.description || '').trim() || (p.stakeholders || []).length || (p.concerns || []).length) {
    fetes.add('problem_situation');
  }
  const r = dades.richPicture || {};
  if ((r.elements || []).length || (r.strokes || []).length) fetes.add('problem_expressed');
  if ((dades.rootDefinitions || []).length) fetes.add('root_definitions');
  if ((dades.conceptualModels || []).length) fetes.add('conceptual_models');
  for (const [camp, etapa] of [['comparison', 'comparison'], ['changes', 'changes'],
                               ['implementation', 'implementation']]) {
    const v = dades[camp] || {};
    if (Object.values(v).some((x) => Array.isArray(x) && x.length)) fetes.add(etapa);
  }
  return fetes;
}

const MAPES_SSM = { ETAPES, CAMPS, desDeLAPI, capALAPI, teContingut, etapesAmbContingut };
export default MAPES_SSM;
